import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { bridge } from "#/shared/constants"
import { BridgeAssetFormValue } from "#/shared/types"
import {
  ComponentStepProps,
  useStepperModalContext,
} from "#/ui/Modal/StepperModal"

export default function SuccessfullyBridgedAssetStep({
  onClickContinue,
}: ComponentStepProps) {
  const {
    values: { token },
  } = useStepperModalContext<BridgeAssetFormValue>()

  const { bridgedTokenSymbol } = bridge.BRIDGEABLE_TOKENS[token]

  return (
    <SuccessfulActionModalBody
      title="Success"
      description={`Congratulations! Your ${bridgedTokenSymbol} will be in your wallet soon.`}
      onClickContinue={onClickContinue}
      nextStepButtonLabel="Done"
    />
  )
}
